import React from 'react'
import { HiOutlineInformationCircle } from 'react-icons/hi';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import Homesuccessstorybutton from '../../../components/Buttons/HomeSuccessStory/Homesuccessstory';



const HomeSuccessstory = () => {
  return (
    <div className=' max-w-7xl ms-4'>
         <div className="flex p-2 justify-center mt-7 gap-2  items-center">
        <span
          data-tooltip-id="successStoryTooltip"
          data-tooltip-html={`
            <div class='tooltip-bubble'>
              <div class='tooltip-content'>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br />
                Nullam id nulla a elit pharetra gravida. Sed porttitor sapien non ex malesuada.
              </div>
              <div class='tooltip-tail'></div>
            </div>
          `}
          className="text-2xl mt-1 cursor-pointer"
        >
          <HiOutlineInformationCircle />
        </span>
        <h1 className="font-semibold text-2xl">Success Story</h1>
      </div>

      <Tooltip
        id="successStoryTooltip"
        place="bottom"
        offset={10}
        className="!bg-transparent !p-0 !rounded-none ms-28 z-30"
      />
                    <div className="bg-[#2E2E2E] text-white rounded-xl p-7  w-[52%] h-[300px] mx-auto flex flex-col items-center shadow-lg relative">
      {/* Left Arrow */}
      <div className="absolute left-4 top-1/2 transform -translate-y-1/2 text-white text-3xl cursor-pointer">
        &#8249;
      </div>

      {/* Right Arrow */}
      <div className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white text-3xl cursor-pointer">
        &#8250;
      </div>

      {/* Quote Icon */}
      <div className="text-4xl text-orange-500 mb-4 mr-[81%] ">❝</div>

      {/* Testimonial Text */}
      <p className="text-center italic leading-relaxed max-w-2xl px-10">
  <div className="space-y-2">
    <span className="block text-xs">
      Lorem Ipsum is simply dummy text of the printing and typesetting industry.
    </span>
    <span className="block text-xs ">
      Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
      </span>
      <span className="block text-xs ">
      when an unknown printer took a galley of type and scrambled it to make a type specimen book.
    </span>
  </div>
</p>


      {/* Profile Image */}
      <div className="mt-3">
        <img
          src="https://randomuser.me/api/portraits/men/32.jpg"
          alt="John Smith"
          className="w-12 h-12 rounded-full border-4 border-orange-500 object-cover"
        />
      </div>

      {/* Name */}
      <p className="text-sm italic">JOHN SMITH</p>
    </div>

    <div className="mt-24 flex justify-center text-xl font-semibold">
        <h1>Edit Your Success Stories  Below Here</h1>
      </div>
      <div className='mt-3'>
        <Homesuccessstorybutton/>
      </div>
    </div>
  )
}
export default HomeSuccessstory;